module.exports = __webpack_public_path__ + "static/media/play-button.f6302268.svg";